export const FEATURE_NAME = '@zerops/zerops/pages/account/modules/account-form';
